<script setup>
import {v4 as uuidv4} from "uuid"
import {computed} from "vue"
import {Vue3SlideUpDown} from "vue3-slide-up-down"

const props = defineProps({
    modelValue: {
        type: [Number, String, Boolean],
        default: ''
    },
    options: {
        type: Object,
        default: () => {
        }
    },
    validator: {
        type: Object,
        default: () => {
        }
    },
    error: {
        type: String,
        default: ''
    }
})

const id = computed(() => `input-${uuidv4()}`)

const model = defineModel()

const errorMessage = computed(() => {
    if (props.validator?.$errors.length) {
        return props.validator.$errors.map(
            error => error.$message
        ).join(', ')
    }

    return props.error
})

const isValidationErrorVisible = computed(() => !!(errorMessage.value))

</script>

<template>
    <div
        :id="id"
        class="inputComponentWrapper"
    >

        <div
            :class="{
                'divCheckboxContainer': true,
                'error': !!errorMessage
            }"
            style="margin-bottom: 15px; display: flex"
            @click="() => model = !model"
        >
            <div :class="{
                'chkCheckbox': true,
                'selected': model === true
            }"/>
            <div class="divCheckboxLabel" style="white-space: unset;">
                <slot />
                <Vue3SlideUpDown v-model="isValidationErrorVisible">
                    <div v-for="$error in validator.$errors" :key="$error" class="validationError">
                        {{ $error.$message }}
                    </div>
                </Vue3SlideUpDown>
            </div>
        </div>
    </div>

</template>

<style>
.inputComponentWrapper {
    display: flex;
    flex-direction: column;
}

.divCheckboxContainer {
    display: flex;
    align-items: center;
}

.divCheckboxContainer.error .divCheckboxLabel {
    color: red !important;
}

.divCheckboxContainer.error .divBorderLine {
    background-color: red;
}

.divCheckboxContainer .validationError {
    color: red;
    font-size: 11px;
}
</style>
